import { render, staticRenderFns } from "./IssueStatus.vue?vue&type=template&id=fa994a8e&scoped=true"
import script from "./IssueStatus.vue?vue&type=script&lang=js"
export * from "./IssueStatus.vue?vue&type=script&lang=js"
import style0 from "./IssueStatus.vue?vue&type=style&index=0&id=fa994a8e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa994a8e",
  null
  
)

export default component.exports